import { http } from '@/utils';
import type { RequestOptions } from '@/utils';

// ==================== API Endpoints ====================
// Note: URLs are relative paths, API_PREFIX will be added automatically by http util
const Api = {
    FindAccount: '/FindAccount',
    AddAccount: '/AddAccount',
    SaveAccount: '/SaveAccount',
    DeleteAccount: '/DeleteAccount',
    GetAccountDetail: '/GetAccountDetail',
    SaveMy: '/SaveMy',
};

// ==================== Account APIs ====================

/**
 * Find accounts with pagination and filters
 */
export async function findAccount(params: API.FindAccountReq): Promise<API.FindAccountRsp> {
    const response = await http.post(Api.FindAccount, params);
    return response.Data;
}

/**
 * Add new account
 */
export async function addAccount(params: API.User): Promise<void> {
    await http.post(Api.AddAccount, params);
}

/**
 * Update account
 */
export async function saveAccount(params: API.User): Promise<void> {
    await http.post(Api.SaveAccount, params);
}

/**
 * Delete account
 */
export async function deleteAccount(params: API.User): Promise<void> {
    await http.post(Api.DeleteAccount, params);
}

/**
 * Get account detail
 */
export async function getAccountDetail(options?: RequestOptions): Promise<{data: API.User;}> {
    const response = await http.get<API.User>(Api.GetAccountDetail, options);
    return {
        data: response.Data || {},
    };
}

/**
 * Save my profile (current user)
 */
export async function saveMy(params: API.SaveMyReq): Promise<void> {
    await http.post(Api.SaveMy, params);
}
